
import React from 'react';
import { Spinner } from '@george-labs.com/design-system';

const GeorgeSpinner = ({size='small'}) => <Spinner screenreaderText="Loading..." size={size}/>;

export default GeorgeSpinner;